import { render } from "./drug.vue?vue&type=template&id=2da0fa08&scoped=true"
import script from "./drug.vue?vue&type=script&lang=js"
export * from "./drug.vue?vue&type=script&lang=js"

import "./drug.vue?vue&type=style&index=0&id=2da0fa08&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da0fa08"]])

export default __exports__